












import { Vue, Prop, Component } from 'vue-property-decorator';

import TextLink from '@/components/Atoms/Link/TextLink.vue';

@Component({
  components: {
    TextLink,
  },
})
export default class footNav extends Vue {
  private footerLinks: { text: string; link: string }[] = [
    { text: '会社概要', link: 'https://www.biglobe.co.jp/' },
    {
      text: 'ウェブアクセシビリティの取り組み',
      link: 'https://support.biglobe.ne.jp/accessibility/?cl=foot_futility_accessibility'
    },
    {
      text: '個人情報保護ポリシー',
      link: 'https://www.biglobe.ne.jp/privacy.html',
    },
    { text: 'Cookieポリシー', link: 'https://www.biglobe.ne.jp/cookie.html' },
    { text: '安心・安全', link: 'https://www.biglobe.ne.jp/safesecurity.html' },
  ];

  isLast(index: number): boolean {
    return index == this.footerLinks.length - 1;
  }
}
